document.addEventListener('DOMContentLoaded', function () {
    initializeQuantitySelectors();
    upsellVariantSelect();
    upsellSelected();
    mattressOptions();
    headboardOptions();
});

function initializeQuantitySelectors() {
    const quantitySelectors = document.querySelectorAll('.product-upsell-popup .quantity-selector');

    quantitySelectors.forEach(selector => {
        const minusBtn = selector.querySelector('.quantity-minus');
        const plusBtn = selector.querySelector('.quantity-plus');
        const quantityValue = selector.querySelector('.quantity-value');

        if (minusBtn && plusBtn && quantityValue) {
            let currentQuantity = quantityValue.value;

            // Update quantity display
            function updateQuantity() {
                quantityValue.value = currentQuantity;

                // Disable minus button if quantity is 1
                minusBtn.disabled = currentQuantity <= 1;

                // Update any related form inputs or hidden fields
                const form = selector.closest('form');
                if (form) {
                    const quantityInput = form.querySelector('input[name="quantity"]');
                    if (quantityInput) {
                        quantityInput.value = currentQuantity;
                    }
                }
            }

            // Minus button click handler
            minusBtn.addEventListener('click', function () {
                if (currentQuantity > 1) {
                    currentQuantity--;
                    updateQuantity();
                }
            });

            // Plus button click handler
            plusBtn.addEventListener('click', function () {
                currentQuantity++;
                updateQuantity();
            });

            // Initialize the display
            updateQuantity();
        }
    });
}

function upsellVariantSelect() {
    const upsell = document.querySelectorAll('.product-upsell-popup');
    upsell.forEach(upsell => {
        const upsellSelector = upsell.querySelector('.upsell-select');
        const upsellPrice = upsell.querySelector('.js-upsell-price');
        const upsellComparePrice = upsell.querySelector('.js-upsell-compare-at-price');
        const saveIndication = upsell.querySelector('.save-indication');
        const saveAmountValue = upsell.querySelector('.save-amount-value');
        const saveAmountPercentage = upsell.querySelector('.save-amount-percentage');

        upsellSelector.addEventListener('change', function () {
            const selectedVariantPrice = upsellSelector.selectedOptions[0].dataset.price;
            const selectedVariantComparePrice = upsellSelector.selectedOptions[0].dataset.comparePrice;
            // Update main price displays
            upsellPrice.innerHTML = formatMoney(selectedVariantPrice, window.theme.moneyFormat);
            upsellComparePrice.innerHTML = formatMoney(selectedVariantComparePrice, window.theme.moneyFormat);

            // Handle sale price display
            if (selectedVariantComparePrice != null) {
                upsellPrice.classList.add('sale');
                upsellComparePrice.classList.remove('hidden');
                upsellComparePrice.innerHTML = formatMoney(selectedVariantComparePrice, window.theme.moneyFormat);
                saveIndication.classList.remove('hidden');
                saveAmountValue.innerHTML = formatMoney(selectedVariantComparePrice - selectedVariantPrice, window.theme.moneyFormat);
                saveAmountPercentage.innerHTML = `${Math.round((selectedVariantComparePrice - selectedVariantPrice) / selectedVariantComparePrice * 100)}%`;
            } else {
                upsellComparePrice.classList.add('hidden');
                saveIndication.classList.add('hidden');
                upsellPrice.classList.remove('sale');
            }
        });
    });
}

function updateProductPricing() {
    const productPriceButtonEls = document.querySelectorAll('.btn-add-to-cart .js-product-price');
    const productPriceText = document.querySelector('.product-wrapper .js-product-price .price');
    const selectedMattressUpsell = document.querySelector('.selected-mattress-upsell');
    const selectedHeadboardUpsell = document.querySelector('.selected-headboard-upsell');

    var total = 0;
    total += Number(productPriceText.dataset.price);

    if(selectedMattressUpsell) {
        if(!selectedMattressUpsell.classList.contains('hidden')) {
            var mattressPrice = selectedMattressUpsell.getAttribute('data-price');
                mattressQuantity = selectedMattressUpsell.getAttribute('data-variant-quantity');

            var mattressTotal = mattressPrice * mattressQuantity;

            total += mattressTotal;
        }
    }

    if(selectedHeadboardUpsell) {
        if(!selectedHeadboardUpsell.classList.contains('hidden')) {
            var headboardPrice = selectedHeadboardUpsell.getAttribute('data-price');
            var headboardQuantity = selectedHeadboardUpsell.getAttribute('data-variant-quantity');

            var headboardTotal = headboardPrice * headboardQuantity;

            total += headboardTotal;
        }
    }

    productPriceButtonEls.forEach(btn => {
        btn.innerHTML = formatMoney(total, window.theme.moneyFormat);
    });
}

function upsellSelected() {
    const upsell = document.querySelectorAll('.product-upsell-popup');
    upsell.forEach(upsell => {
        const type = upsell.dataset.type;
        const closeButton = upsell.querySelector('.product-upsell-popup-close-button');
        const selectButton = upsell.querySelector('.btn-select-variant');

        selectButton.addEventListener('click', function (e) {
            const selectedVariantId = upsell.querySelector('.upsell-select').value;
            const selectedVariantQuantity = upsell.querySelector('.quantity-value').value;

            const selectedTitle = upsell.querySelector('.upsell-product-title').textContent;
            const selectedVariantTitle = upsell.querySelector('.upsell-select option:checked').textContent;

            const selectedVariantPrice = Number(upsell.querySelector('.upsell-select option:checked').dataset.price);

            const combinedTitle = `${selectedTitle} - ${selectedVariantTitle}`;

            closeButton.click();

            if (type === 'mattress') {
                document.querySelector('.selected-mattress-upsell').classList.remove('hidden');
                document.querySelector('.selected-mattress-upsell').setAttribute('data-variant-id', selectedVariantId);
                document.querySelector('.selected-mattress-upsell').setAttribute('data-variant-quantity', selectedVariantQuantity);
                document.querySelector('.selected-mattress-upsell').setAttribute('data-price', selectedVariantPrice);
                document.querySelector('.selected-mattress').textContent = combinedTitle;
                document.querySelector('.mattress-upsell').classList.add('hidden');
            } else if (type === 'headboard') {
                document.querySelector('.selected-headboard-upsell').classList.remove('hidden');
                document.querySelector('.selected-headboard-upsell').setAttribute('data-variant-id', selectedVariantId);
                document.querySelector('.selected-headboard-upsell').setAttribute('data-variant-quantity', selectedVariantQuantity);
                document.querySelector('.selected-headboard-upsell').setAttribute('data-price', selectedVariantPrice);
                document.querySelector('.selected-headboard').textContent = combinedTitle;
                document.querySelector('.headboard-upsell').classList.add('hidden');
            }

            updateProductPricing();
        });
    });
}

function mattressOptions() {
    const mattressUpsell = document.querySelector('.mattress-upsell');

    if (mattressUpsell) {
        const selectedMattress = document.querySelector('.selected-mattress-upsell');
        const mattressChange = selectedMattress.querySelector('.btn-change');
        const mattressRemove = selectedMattress.querySelector('.btn-remove');

        mattressChange.addEventListener('click', function () {
            mattressUpsell.classList.remove('hidden');
            selectedMattress.setAttribute('data-variant-id', '');
            selectedMattress.setAttribute('data-variant-quantity', '');
            selectedMattress.classList.add('hidden');
            selectedMattress.setAttribute('data-price', '0');
            updateProductPricing();
        });

        mattressRemove.addEventListener('click', function () {
            selectedMattress.classList.add('hidden');
            selectedMattress.setAttribute('data-variant-id', '');
            selectedMattress.setAttribute('data-variant-quantity', '');
            selectedMattress.setAttribute('data-price', '0');
            updateProductPricing();

            mattressUpsell.classList.remove('hidden');
            mattressUpsell.querySelector('summary').click();
        });
    }
}

function headboardOptions() {
    const headboardUpsell = document.querySelector('.headboard-upsell');

    if (headboardUpsell) {
        const selectedHeadboard = document.querySelector('.selected-headboard-upsell');
        const headboardChange = selectedHeadboard.querySelector('.btn-change');
        const headboardRemove = selectedHeadboard.querySelector('.btn-remove');

        headboardChange.addEventListener('click', function () {
            headboardUpsell.classList.remove('hidden');
            selectedHeadboard.setAttribute('data-variant-id', '');
            selectedHeadboard.setAttribute('data-variant-quantity', '');
            selectedHeadboard.classList.add('hidden');
            selectedHeadboard.setAttribute('data-price', '0');

            updateProductPricing();
        });

        headboardRemove.addEventListener('click', function () {
            selectedHeadboard.classList.add('hidden');
            selectedHeadboard.setAttribute('data-variant-id', '');
            selectedHeadboard.setAttribute('data-variant-quantity', '');
            selectedHeadboard.setAttribute('data-price', '0');
            
            updateProductPricing();

            headboardUpsell.classList.remove('hidden');
            headboardUpsell.querySelector('summary').click();
        });
    }
}
